import _slicedToArray from '@babel/runtime-corejs3/helpers/slicedToArray';
import { useState, useRef } from 'react';

function useTooltip() {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showTooltip = _useState2[0],
    setShowTooltip = _useState2[1];
  var $tooltipButton = useRef(null);
  var handleTooltip = function handleTooltip(e) {
    e.stopPropagation();
    setShowTooltip(!showTooltip);
  };
  return {
    showTooltip: showTooltip,
    $tooltipButton: $tooltipButton,
    handleTooltip: handleTooltip
  };
}

export { useTooltip as default };
